import { render, staticRenderFns } from "./HealthcheckDetails.vue?vue&type=template&id=798ddde2&scoped=true&"
import script from "./HealthcheckDetails.vue?vue&type=script&lang=js&"
export * from "./HealthcheckDetails.vue?vue&type=script&lang=js&"
import style0 from "./HealthcheckDetails.vue?vue&type=style&index=0&id=798ddde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ddde2",
  null
  
)

export default component.exports